// extracted by mini-css-extract-plugin
module.exports = {"loaderIcon":"style_loaderIcon__Wm_7T","spin":"style_spin__o_avI"};